window.onload = (event) => {
    let chatButtonFrame = document.querySelector("#ShopifyChat");
    let chatButtonButton = chatButtonFrame.contentWindow.document.querySelector("button");
    chatButtonButton.addEventListener("click", sendFocusToChat());
    chatButtonButton.addEventListener("keypress", function(keyboard) {
      if (keyboard.key === "Enter") {
        sendFocusToChat();
      };
    })
    function sendFocusToChat() {
        let chatWidgetFrame = document.querySelector("#ShopifyChat");
        let chatTextArea = chatWidgetFrame.contentWindow.document.querySelector("textarea");
        chatTextArea.focus();
    }
  }; 